import React, { useState, useRef } from 'react';
// import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

import { MdSend } from 'react-icons/md';
import PropTypes from 'prop-types';
import emailjs from '@emailjs/browser';
import MuiSnackbar from '../../components/ui/MuiSnackbar';
import Input from '../../components/ui/Input';
import useInput from '../../hooks/useInput.js';
import SubTitle from '../../components/ui/SubTitle';

// https://www.youtube.com/watch?v=Yg6POD0M30w

function ContactForm({ className }) {
  // state For Loading Button
  const [loading, setLoading] = useState(false);

  // state For Snackbar after submittion
  const [snackbarIsOpen, setSnackbarIsOpen] = useState(false);
  const [snackbarInfo, setSnackbarInfo] = useState({
    severity: 'success',
    message: 'Form submitted successfully!',
  });

  const openSnackbar = () => setSnackbarIsOpen(true);

  const closeSnackbar = (e, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarIsOpen(false);
  };

  const stringValidation = (str, length) => str.trim().length >= length;

  const {
    value: enteredName,
    isValid: enteredNameIsValid,
    hasError: nameInputHasError,
    valueChangeHandler: nameChangeHandler,
    inputBlurHandler: nameBlurHandler,
    reset: resetNameInput,
  } = useInput((value) => stringValidation(value, 3));

  const {
    value: enteredEmail,
    isValid: enteredEmailIsValid,
    hasError: emailInputHasError,
    valueChangeHandler: emailChangeHandler,
    inputBlurHandler: emailBlurHandler,
    reset: resetEmailInput,
  } = useInput((value) => value.includes('@'));

  const {
    value: enteredSubject,
    isValid: enteredSubjectIsValid,
    hasError: subjectInputHasError,
    valueChangeHandler: subjectChangeHandler,
    inputBlurHandler: subjectBlurHandler,
    reset: resetSubjectInput,
  } = useInput((value) => stringValidation(value, 5));

  const {
    value: enteredMessage,
    isValid: enteredMessageIsValid,
    hasError: messageInputHasError,
    valueChangeHandler: messageChangeHandler,
    inputBlurHandler: messageBlurHandler,
    reset: resetMessageInput,
  } = useInput((value) => stringValidation(value, 30));

  const formReset = () => {
    resetNameInput();
    resetEmailInput();
    resetSubjectInput();
    resetMessageInput();
  };

  let formIsValid = false;

  if (
    enteredNameIsValid &&
    enteredEmailIsValid &&
    enteredSubjectIsValid &&
    enteredMessageIsValid
  ) {
    formIsValid = true;
  }

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        'service_is8i0fo',
        'template_3bjf686',
        form.current,
        'bxwR6M6WbNVkh7Ycj'
      )
      .then(
        (result) => {
          console.log(result.text);
          formReset();
          setLoading(false);
          setSnackbarInfo({
            severity: 'success',
            message: 'Form submitted successfully!',
          });
          openSnackbar();
        },
        (error) => {
          console.log(error.text);
          setLoading(false);
          setSnackbarInfo({
            severity: 'error',
            message: error.text || 'Network is off now , please check',
          });
          openSnackbar();
          setLoading(false);
        }
      );
  };

  // const formSubmissionHandler = (event) => {
  //   event.preventDefault();

  //   if (!formIsValid) return;

  //   console.log(enteredName);
  //   console.log(enteredEmail);
  //   console.log(enteredSubject);
  //   console.log(enteredMessage);

  //   resetNameInput();
  //   resetEmailInput();
  //   resetSubjectInput();
  //   resetMessageInput();
  // };

  return (
    <div className={`${className || ''}`}>
      <SubTitle>Start Messsage Me</SubTitle>
      <form
        className="grid  md:grid-cols-2 gap-10"
        ref={form}
        onSubmit={sendEmail}
      >
        {/* <form
        action=""
        className="grid  md:grid-cols-2 gap-10"
        onSubmit={formSubmissionHandler}
      > */}
        <Input
          inputValue={enteredName}
          inputHasError={nameInputHasError}
          onChangeInput={nameChangeHandler}
          onBlurInput={nameBlurHandler}
          inputInfo={{
            id: 'name',
            name: 'Your Name',
            errMessage: 'Please insert a valid name at least 3 character.',
            type: 'oneline',
          }}
        />
        <Input
          inputValue={enteredEmail}
          inputHasError={emailInputHasError}
          onChangeInput={emailChangeHandler}
          onBlurInput={emailBlurHandler}
          inputInfo={{
            id: 'email',
            name: 'Your Email',
            errMessage: 'Please insert a valid emaill.',
            type: 'oneline',
          }}
        />
        <Input
          inputValue={enteredSubject}
          inputHasError={subjectInputHasError}
          onChangeInput={subjectChangeHandler}
          onBlurInput={subjectBlurHandler}
          inputInfo={{
            id: 'subject',
            name: 'subject',
            errMessage: 'Please insert a valid subject at least 5 character',
            type: 'oneline',
          }}
        />
        <Input
          inputValue={enteredMessage}
          inputHasError={messageInputHasError}
          onChangeInput={messageChangeHandler}
          onBlurInput={messageBlurHandler}
          inputInfo={{
            id: 'message',
            name: 'Your Meaasge',
            errMessage: 'Please insert a valid Meassge at least 30 characters',
            type: 'multiline',
          }}
        />
        {/* <Button
          type="submit"
          size="large"
          variant="contained"
          disabled={!formIsValid}
          endIcon={<MdSend />}
        >
          send
        </Button> */}
        <LoadingButton
          type="submit"
          size="large"
          variant="contained"
          disabled={!formIsValid}
          endIcon={<MdSend />}
          loading={loading}
          loadingPosition="end"
        >
          Send
        </LoadingButton>
        <MuiSnackbar
          snackbarIsOpen={snackbarIsOpen}
          closeSnackbar={closeSnackbar}
          info={snackbarInfo}
        />
      </form>
    </div>
  );
}

export default ContactForm;

ContactForm.propTypes = {
  className: PropTypes.string,
};
